export const init = section => {
  const cardsList = section.querySelector('.js-cards-list');
  const cards = cardsList.querySelectorAll('.js-card');
  const toggleButton = section.querySelector('.js-toggle');
  const showText = toggleButton.querySelector('span:nth-child(1)');
  const hideText = toggleButton.querySelector('span:nth-child(2)');
  const buttonIcon = toggleButton.querySelector('svg');

  let expanded = false;

  toggleButton.addEventListener('click', function () {
    expanded = !expanded;

    cards.forEach((card, index) => {
      if (index >= 6) {
        if (expanded) {
          card.classList.remove(
            'max-md:overflow-hidden',
            'max-md:max-h-0',
            'max-md:opacity-0',
            'max-md:mb-0',
          );
          card.classList.add('max-md:max-h-screen', 'max-md:opacity-100', 'max-md:mb-4');
        } else {
          card.classList.remove('max-md:max-h-screen', 'max-md:opacity-100', 'max-md:mb-4');
          card.classList.add(
            'max-md:overflow-hidden',
            'max-md:max-h-0',
            'max-md:opacity-0',
            'max-md:mb-0',
          );
        }
      }
    });

    buttonIcon.classList.toggle('rotate-180');
    showText.classList.toggle('hidden', expanded);
    hideText.classList.toggle('hidden', !expanded);
  });
};
